var generateStyle = function generateStyle() {
  return {
    wrapper: {
      width: '100%',
      height: '100%',
      display: 'inline-flex',
      flex: '1 1 auto',
      alignItems: 'center',
      justifyContent: 'center',
      columnGap: '10px'
    }
  };
};
export default generateStyle;